import { useMutation } from "react-query";
import { snoozeNotification } from "../../../../../api-services/account-information/snoozeNotification";

export const useSnoozeNotificationMutation = () =>
  useMutation(snoozeNotification);
